import { SectionHeader } from '../../components/ui';
// T129/T270(6) — the labelled sections of the dashboard: Today, Work queue, System.
// T129 — labelled dashboard zone (TODAY / WORK QUEUE / SYSTEM). Pure layout
// wrapper around existing children; tone 'accent' = brand eyebrow (TODAY reads
// first), 'muted' = slate (demoted). Keeps the app's mt-8 section rhythm.
export default function Zone({ title, hint, tone = 'muted', children }) {
  return (
    <section className="mt-8">
      <SectionHeader title={title} hint={hint} tone={tone} />
      <div className="mt-3 space-y-4">{children}</div>
    </section>
  );
}
